<template>
    <ul class="questions-lists">
      <li v-for="(item,index) in querstions" :key="index">
        <p class="title">{{item.title}}</p>
        <p class="content">{{item.content}}</p>
        <div class="icon_wrapper">
          <img src="../../assets/images/m_faq_question_border@3x.png" />
        </div>
      </li>
    </ul>
</template>

<script>
import ArticleThumbnail from './ArticleThumbnail'

export default {
  name:"articleitem",
  props:['articleLists'],
  props:[
    'querstions'
  ],
  data(){
    return{
      
    }
  },
  components:{
    ArticleThumbnail,//缩略图
  },
  filters:{
    dateparse(val){
      var dateArr = val.split(" ")
      return dateArr[0]
    },
    readparse(val){
      if(val>1000000){
        return "10万+";
      }else{
        return val;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/css/base.scss';
 .questions-lists{
      width:px2vw(355px);
      margin:0 auto;
      li{
        padding: pxtorem(16px) pxtorem(22px) pxtorem(16px) pxtorem(34px);
        position: relative;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 4px 0px rgba(0,0,0,0.1);
        border-radius:pxtorem(6px);
        &+li{
          margin-top:pxtorem(10px);
        }
        .icon_wrapper{
          img{
            height: pxtorem(31px);
            position: absolute;
            top:pxtorem(10px);
            left: pxtorem(-8px);

          }
        }
        .title{
            font-size:pxtorem(16px);
            color:rgba(26,26,26,1);
        }
        .content{
          font-size:pxtorem(13px);
          color:rgba(89,89,89,1);
          line-height: pxtorem(19px);
          margin-top:pxtorem(13px);
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/QuestionItem.vue